<form id="medprodidForm" (submit)="onDeaSubmit($event)">
  <dx-form
    [(formData)]="license"
    [showColonAfterLabel]="false"
    validationGroup="deaData"
    labelLocation="top"
    [showValidationSummary]="true"
  >
    <dxi-item colCount="2" itemType="group" [cssClass]="'box'">
      <dxi-item *ngIf="regDetails" dataField="user.first_name">
        <dxo-label text="First Name" [showColon]="false"></dxo-label>
        <dxi-validation-rule
          type="required"
          message="First name is required"
        ></dxi-validation-rule>
      </dxi-item>
      <dxi-item *ngIf="regDetails" dataField="user.last_name">
        <dxo-label text="Last Name"></dxo-label>
        <dxi-validation-rule
          type="required"
          message="Last name is required"
        ></dxi-validation-rule>
      </dxi-item>
      <dxi-item *ngIf="regDetails" dataField="user.email">
        <dxo-label text="Email"></dxo-label>
        <dxi-validation-rule
          type="required"
          message="Email is required"
        ></dxi-validation-rule>
        <dxi-validation-rule
          message="Email is invalid"
          type="email"
        ></dxi-validation-rule>
      </dxi-item>
      <dxi-item
        *ngIf="regDetails"
        dataField="user.phone"
        [editorOptions]="{ maxLength: 10 }"
      >
        <dxo-label text="Phone Number"></dxo-label>
        <dxi-validation-rule
          type="required"
          message="Phone number is required"
        ></dxi-validation-rule>
      </dxi-item>
      <dxi-item
        dataField="number"
        [editorOptions]="{ placeholder: 'AA1234567', hint: '' }"
      >
        <dxo-label text="State license or DEA number"></dxo-label>
        <dxi-validation-rule
          type="required"
          message="DEA or State license number is required"
        ></dxi-validation-rule>
      </dxi-item>
      <dxi-item
        dataField="state"
        editorType="dxSelectBox"
        [editorOptions]="{
          dataSource: states,
          displayExpr: 'name',
          valueExpr: 'abbreviation',
          placeholder: 'State...',
          acceptCustomValue: true,
          searchEnabled: true,
          searchExpr: searchExprOption,
          hint: '',
        }"
      >
        <dxi-validation-rule
          type="required"
          message="State is required"
        ></dxi-validation-rule>
        <dxo-label text="State"></dxo-label>
        <dxi-validation-rule
          type="required"
          message="State is required"
        ></dxi-validation-rule>
      </dxi-item>
      <dxi-item
        colSpan="2"
        itemType="button"
        [cssClass]="'submit'"
        horizontalAlignment="right"
        [buttonOptions]="deaButtonOptions"
        [cssClass]="'pr-0'"
      >
      </dxi-item>
    </dxi-item>
  </dx-form>
  <div *ngIf="errorSearchMessage" class="alert alert-danger">
    <div>
      {{ errorSearchMessage }}
    </div>
    <p>
      Please check the state or DEA license number and try again. If your
      current active state or DEA license is not being returned by the search,
      or for any further assistance, please contact customer support at
      {{ client?.comm_phone || '844-733-5633' }} or
      {{ client?.comm_email || 'info&#64;medigi.com' }}.
    </p>
  </div>
</form>

<dx-load-panel
  #loadPanel
  shadingColor="rgba(0,0,0,0.2)"
  [position]="{ of: '#medprodidForm' }"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
>
</dx-load-panel>
